import { Button } from '@gearbelt/ui/components';
import { Products } from '@site-mate/sitemate-global-shared';

import MultipleWorkspacesInAnAccountDashpivot from '@/assets/workspace-switcher/multiple-workspaces-in-an-account-dashpivot.svg';
import MultipleWorkspacesInAnAccount from '@/assets/workspace-switcher/multiple-workspaces-in-an-account.svg';
import { useWorkspaceSwitcherStore } from '@/stores/workspace-switcher-store';

import SendIcon from '../icons/send';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

const DASHPIVOT_LEARN_MORE_URL = 'https://help.sitemate.com/en/articles/9205707-what-is-a-dashpivot-workspace';

const WorkspaceSwitcherUpgradePlanModal = () => {
  const { isUpgradePlanOpen, setIsUpgradePlanOpen, upgradePlanProduct } = useWorkspaceSwitcherStore();

  const mailTo = 'mailto:info@sitemate.com?subject=Upgrade%20Subscription%20-%20Unlock%20additional%20workspaces';
  const isDashpivot = upgradePlanProduct === Products.Dashpivot;

  return (
    <Dialog open={isUpgradePlanOpen} onOpenChange={setIsUpgradePlanOpen}>
      <DialogContent className="top-0 mt-25 w-[500px] border-white">
        <DialogHeader>
          <DialogTitle></DialogTitle>
        </DialogHeader>

        <div className="flex flex-col items-center gap-y-4 text-center">
          <img src={isDashpivot ? MultipleWorkspacesInAnAccountDashpivot : MultipleWorkspacesInAnAccount} alt="Multiple Workspaces in an Account" />

          <h1 className="text-xl font-medium">Unlock additional workspaces</h1>

          <span className="text-sm">
            Contact us to upgrade your subscription plan and enable creation of additional {upgradePlanProduct} workspaces.
            {isDashpivot && (
              <>
                {' '}
                <a href={DASHPIVOT_LEARN_MORE_URL} target="_blank" rel="noopener noreferrer" className="text-default-blue underline">
                  Learn more
                </a>
              </>
            )}
          </span>

          <div className="flex items-center gap-2">
            <Button variant={'success'} icon={<SendIcon />} className="p-2" onClick={() => (window.location.href = mailTo)}>
              Email us
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WorkspaceSwitcherUpgradePlanModal;
